export default __webpack_public_path__ + "static/media/SortMarshal_white.25a5fd8d.png";